import React from "react"
import Footer from "../components/Footer"
import Header from "../components/Header"
import SecondaryResourcesCategoryView from "../components/SecondaryResourcesCategoryView"
import ZipLogo from "../images/zip.svg"
import Grade6TB from "../images/primary-6.jpg"

class Primary5Resources extends React.Component {
  state = {
    view: {
      title: "Primary 6 Resources",
      parentURL: "/resources",
      parentName: "resources",
      categories: [
        {
          name: "Teacher's Book",
          file: Grade6TB,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-nov-2022/G6-Primary-6-TB_WM_2022.pdf",
        },
        {
          name: "Audio",
          fileType: ZipLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/audio-april-2022/",
          files: [{ name: "Grade 6 Audio", file: "Primary-6-audio.zip" }],
        },
      ],
    },
  }

  render() {
    return (
      <div>
        <Header />

        <SecondaryResourcesCategoryView data={this.state.view} />

        <Footer />
      </div>
    )
  }
}

export default Primary5Resources



// WEBPACK FOOTER //
// ./src/components/ResourcesPrimary6.js